var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 94,
    viewBox: "0 0 53 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2879_7164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.940578 9.51683C8.64243 15.4625 15.9426 22.8853 22.5583 31.4397C29.1741 39.9942 35.0514 49.556 40.0811 59.9451C42.915 65.794 45.401 71.8929 47.661 78.1359C47.776 78.4562 48.0244 79.0778 48.311 79.0857C48.5977 79.0936 48.4768 78.4771 48.392 78.2329C44.4423 66.7441 39.2138 55.7806 33.2913 45.8778C27.3843 36.0007 20.6829 27.0559 13.3938 19.4256C9.28956 15.1199 5.00514 11.2456 0.58804 7.8406C0.30106 7.61807 0.299239 8.15032 0.348099 8.40755C0.427771 8.82853 0.66081 9.29754 0.940578 9.51683Z",
    fill: "#344157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3878 71.734C48.8915 73.7759 49.3615 75.8255 49.7842 77.881C49.9876 78.8739 50.1838 79.8636 50.3677 80.8561C50.5261 81.7081 50.7786 82.6606 50.788 83.5123C50.7974 84.364 50.4404 84.6014 49.8981 84.1248C49.2814 83.5772 48.6866 82.9271 48.0881 82.3315C46.8177 81.0741 45.5544 79.8053 44.2689 78.5952C44.026 78.3675 43.8592 78.4738 43.8802 78.8642C43.9013 79.2839 44.1461 79.8332 44.4005 80.0973C45.7995 81.5499 47.2299 82.9416 48.6533 84.3448C49.4544 85.1333 51.4164 87.5799 51.7103 85.2881C51.8172 84.4636 51.6142 83.5437 51.462 82.6904C51.2555 81.542 51.0357 80.3918 50.8046 79.249C50.336 76.921 49.811 74.6009 49.2378 72.2967C49.1419 71.9039 48.9328 71.3269 48.6297 71.1617C48.3452 71.007 48.3067 71.4207 48.3858 71.7394L48.3878 71.734Z",
    fill: "#344157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2879_7164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.7455,
    height: 33.5205,
    fill: "white",
    transform: "translate(32.9023 0.400391) rotate(77.1726)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow3.f38efd72.svg";
export { ForwardRef as ReactComponent };